import { Section, Syllabus } from "../../providers/LearnerClassroomProvider";

/**
 * V2 learner classroom layout currently applies only to self-paced sections.
 */
export function isLearnerClassroomV2Layout(
  section: Section | undefined,
  syllabus: Syllabus | undefined,
): boolean {
  return section?.is_self_paced === true && syllabus?.layoutVersion === 2;
}
